<template>
  <div class="row">
    <div class="col-12">
      <div class="form-group">
        <div class="form-group--inside">
          <h4>LLM Instructions</h4>

          <div class="description">Define specific instructions for the LLM.</div>

          <div class="form-group--inside">
            <div class="col-2">
              <h4 class="mt">
                Output Type
                <Tooltip title="Set the output type for the LLM. This defines how the LLM will respond. " />
              </h4>
              <Dropdown :items="llmOutputTypes" v-model="outputType" @input="setOutputType($event)" placeholder="Select output type" />
            </div>
          </div>

          <h4 class="mt">
            Format Instructions
            <Tooltip
              title="Set the format instructions for the LLM like a JSON schema or a text format. This is used to control the output of the LLM but is dependend on the quality of the model and will not always be 100% correct."
            />
          </h4>
          <div class="form-group--inside">
            <Autocomplete
              :items="variables"
              name="formatInstructions"
              id="formatInstructions"
              v-model="formatInstructions"
              :rows="5"
              placeholder="Enter formatting instructions for the bot"
            />
          </div>

          <h4 class="mt">
            History Instructions
            <Tooltip
              title="Set the history instructions for the LLM. This is used if you want to use the conversation history to answer the user's question and fine-tune the response."
            />
          </h4>
          <div class="form-group--inside">
            <Autocomplete
              :items="variables"
              name="historyInstructions"
              id="historyInstructions"
              v-model="historyInstructions"
              :rows="3"
              placeholder="Enter formatting instructions for the bot"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import { LLMObject, llmOutputType } from '../../../../../../common/types/llm-type'
import Autocomplete from '@/components/helpers/Autocomplete.vue'
import Dropdown from '@/components/helpers/Dropdown.vue'
import Toggle from '@/components/helpers/Toggle.vue'
import Tooltip from '@/components/helpers/Tooltip.vue'

@Component({ components: { Autocomplete, Dropdown, Toggle, Tooltip } })
export default class LLMInstructions extends Vue {
  @Prop() LLM: LLMObject
  @Prop() variables: string[]

  llmOutputTypes = ['text', 'json']

  get formatInstructions() {
    return this.LLM.formatInstructions
  }

  set formatInstructions(value: string) {
    this.LLM.formatInstructions = value
  }

  get historyInstructions() {
    return this.LLM.historyInstructions
  }

  set historyInstructions(value: string) {
    this.LLM.historyInstructions = value
  }

  get outputType() {
    return this.LLM.output === 'json' ? 'json' : 'text'
  }

  set outputType(value: llmOutputType | string) {
    const outputType = value === 'text' ? 'string' : value
    this.LLM.output = outputType as llmOutputType
  }

  setOutputType(event: any) {
    const outputType = event === 'text' ? 'string' : event
    this.LLM.output = outputType as llmOutputType
  }
}
</script>

<style scoped lang="scss">
@import '../../../../assets/scss/variables';

.description {
  font-size: 14px;
  margin-bottom: 15px;
}

.mt {
  margin-top: 20px;
}

.dot-wrapper {
  display: flex;
  margin: 0px 0px -15px 0px;
  .dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;

    &.red {
      background-color: $red;
    }

    &.green {
      background-color: $green;
    }
  }
  .description {
    margin-left: 10px;
    margin-top: -5px;
  }
}
</style>
